// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"dd4325b1","345":"14627c97","643":"a13fbe2c","787":"7b79f915","949":"84e68b1f","972":"5e637ded"}[chunkId] + ".chunk.js";
};